module.exports = __webpack_public_path__ + "media/images/admin/icons/star-8070f2335a60a0172b4cde8fddb5b020.svg";